<template>
  <div >
    <c-table-search :queryParams="queryParams" @doSearch="queryData">
      <template v-slot:btns>
        <!-- <el-form-item>
          <el-button type="primary" @click="openModel('costModel')">添加</el-button>
        </el-form-item> -->
      </template>
    </c-table-search>
    <div class="block">
    
    <c-table @handlePageChange="handlePageChange" :dataSource="dataSource" :pagination="pagination">
      <template>
           <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="{row}">{{row.createTime | DateFilter('medium')}}</template>
        </el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="content" label="主题"></el-table-column>
         <el-table-column prop="isRead" label="状态">
          <template slot-scope="{row}">{{row.isRead==0?'未读':'已读'}}</template>
        </el-table-column>
        <!-- <el-table-column prop="type" label="类型">
        </el-table-column> -->
        <el-table-column prop="code" label="操作">
          <template slot-scope="{row}">
            <div class="actions">
              <!-- <a @click="handleDelete(row)">编辑</a>
              <el-divider direction="vertical"></el-divider> -->
              <a @click="goDetail(row.id)">查看</a>
              <!-- <el-divider direction="vertical"></el-divider>
              <a @click="handleDelete(row)">删除</a> -->
            </div>
          </template>
        </el-table-column>
      </template>
    </c-table>
    </div>
  </div>
</template>

<script>
import { notifyRes } from "@/api";
import { PAGE_SIZE } from "@/config/GlobalText";
import TableMixin from "@/mixins/TableMixin";
import { mapGetters } from "vuex";
import CLinkModel from "./components/C-Link-Model";
export default {
  mixins: [TableMixin],
  components: { CLinkModel },
  data: function() {
    return {
      queryParams: [
        // {
        //   label: "检索",
        //   code: "q"
        // },
        {
          label: "类型",
          type: "select",
          code: "isRead",
          options:[
            {name:"全部",value:''},
            {name:"已读",value:1},
            {name:"未读",value:0},
          ]
        }
      ],
      info: {
        title: "",
        description: "123123",
        startTime: "",
        endTime: ""
      },
      pageNum:1
    };
  },
  mounted() {
    this.getNotifyList();
  },
  computed: {
    ...mapGetters(["getRecruitList"])
  },
  methods: {
    getNotifyList(params) {
      const data = { ...params, pageSize: PAGE_SIZE,pageNum:this.pageNum };
      notifyRes.getPage(data).then(res => {
        const { total, records } = res;
        this.pagination.total = total;
        this.dataSource = records;
      });
    },
    handlePageChange(pageNum){
        this.pageNum = pageNum
        this.getNotifyList()
    },
    goDetail(id){
      this.$router.push('/common/contentDetails/'+id)
    },
    handleDelete(record) {
      console.log(record);
    },
    queryData(data){
      this.getNotifyList(data)
    }
  }
};
</script>
<style lang="scss" scoped>
.editLink {
  text-decoration: underline;
  color: $main-color;
}
</style>


